import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'types';

import { initialState } from './reducer';

const selectDomain = (state: RootState) => state?.userStore || initialState;

export const selectUserInformation = createSelector([selectDomain], (state) => state.information);

export const selectActiveUnit = createSelector(
  [selectDomain],
  (state) => state.information?.activeUnit ?? ''
);

export const selectUserEmail = createSelector([selectDomain], (state) => state.information?.email);

export const selectUserAuthorized = createSelector([selectDomain], (state) => state.authorized);

export const selectUserHandling = createSelector([selectDomain], (state) => state.handling);
